/** 
 * @module: 任务选择目标和kr
 * @author: yuanxm
 * @date: 2020-06-01 15:17:56
 */

import { observable, action } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import _ from 'lodash';
import { IOKRData, IOKRUser } from '@src/entity/okr/okr';
import { IKRData } from '@src/entity/okr/kr';
import { KR_STATUS, CHECK_STATUS } from '@src/utils/constant';

class TaskOKR {
  // 我创建的
  @observable ownOKRList: IOKRData[] = [];
  // 我负责的
  @observable manageOKRList: IOKRData[] = [];
  // 我参与的
  @observable joinedOKRList: IOKRData[] = [];
  // 选择的目标下的kr列表
  @observable krList: IKRData[] = [];
  // 关联目标的目标
  @observable curOKR?: IOKRData;
  // 关联目标的kr 只显示【KR进度状态==进行中 且 KR审批状态=已撤回 or 审核失败 or 审核成功 or 验收失败】的KR信息
  @observable curKR?: IKRData;

  @action.bound
  setCurData(okr?: IOKRData, kr?: IKRData) {
    this.curOKR = okr;
    this.curKR = kr;
  }

  @action.bound
  async getOKRList(me: 'create' | 'manage' | 'follow') {
    const res = await ajax.getJson('/okr/api/okr/targets', { me });
    if (+res.error_code === 0) {
      const list = res.result;
      if (me === 'create') {
        this.ownOKRList = list;
      } else if (me === 'manage') {
        this.manageOKRList = list;
      } else if (me === 'follow') {
        this.joinedOKRList = list;
      }
    }
    return res;
  }

  /**
   * 获取OKR下的KR列表
   *
   * @param {string} uuid 目标uuid
   * @memberof OKR
   */
  @action.bound
  async getKRListByOKR(uuid: string) {
    const res = await ajax.getJson(`/okr/api/okr/targets/krs/${uuid}`);
    if (+res.error_code === 0) {
      // 只显示【KR进度状态==进行中 且 KR审批状态=已撤回 or 审核失败 or 审核成功 or 验收失败】的KR信息
      this.krList = ((res.result || []) as IKRData[]).filter(
        (k) =>
          k.status === KR_STATUS.PROCESS &&
          [
            CHECK_STATUS.WITHDRAW,
            CHECK_STATUS.REJECT,
            CHECK_STATUS.PASS,
            CHECK_STATUS.ACCEPT_REJECT
          ].includes(k.check_status)
      );
    }
  }

  /**
   * 查询目标下面的参与者（负责人、参与人[、创建人]）
   *
   * @param {string} uuid 目标uuid
   * @param {boolean} [includeCreator=false] 是否返回创建人
   * @returns 
   * @memberof OKR
   */
  @action.bound
  async getUserListByOKR(
    uuid: string,
    includeCreator: boolean = false
  ): Promise<IOKRUser[]> {
    const res = await ajax.getJson(
      `/okr/api/okr/targets/users/${uuid}`,
      includeCreator ? { creator: 1 } : {}
    );
    if (+res.error_code === 0) {
      return res.result;
    }
    return [];
  }
}

export default TaskOKR;
